import { NgxSpinnerService } from 'ngx-spinner';
import { ToastService } from 'src/app/core/toast.service';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SupplyOrders } from 'src/app/modules/dashboard/modules/my-orders/models/supply-orders';
import { ChangeStatusService } from 'src/app/modules/dashboard/modules/my-orders/services/change-status.service';
@Component({
    selector: 'app-cancel-order',
    templateUrl: './cancel-order.component.html',
    styleUrls: ['./cancel-order.component.scss']
})
export class CancelOrderComponent implements OnInit {
  /* --------------------------- change status form --------------------------- */
  changeStatusForm = this.fb.group({
    status: ['CANCELLED', [Validators.required]],
    invoice: [null],
    message: ["Order cancelled", [Validators.required]]
  });
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private fb: FormBuilder,
    private _dialogRef: MatDialogRef<CancelOrderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SupplyOrders,
    private changeStatusService: ChangeStatusService,
    private toast: ToastService,
    private spinner: NgxSpinnerService
  ) { }
/* ---------------------------- Life cycle hooks ---------------------------- */
  ngOnInit(): void {
  }

  /* ---------------------------- Custom Functions ---------------------------- */
  dialogClose(status: string) {
    // this._dialogRef.close(status);    
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(status); }, 1000);
  }

  /* --------------------------------- Getters -------------------------------- */
  get status(){
    return this.changeStatusForm.get('status');
  }
  get invoice(){
    return this.changeStatusForm.get('invoice');
  }
  get message(){
    return this.changeStatusForm.get('message');
  }
  async updateStatus(){
    if(this.changeStatusForm.invalid){
      this.toast.openSnackBar('Please enter valid details');
      return;
    }
    this.spinner.show();
    try {
      await this.changeStatusService.changeStatus(
        this.data.id, {
          status: this.status.value
        } , {
          supplies_order_id : this.data.id,
          status: this.status.value,
          message: this.message.value
        });
        this.spinner.hide();
        this.toast.openSnackBar('Order cancelled successfully');
        this.dialogClose('yes');
    } catch(error) {
      this.spinner.hide();
       this.toast.openSnackBar('Unable to cancel order');
    }
  }
}

